import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CreatePage from './pages/CreatePage';
import ProjectsPage from './pages/ProjectsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CharacterSettingPage from './pages/CharacterSettingPage';
import StoryboardPage from './pages/StoryboardPage';
import ResourceCenterPage from './pages/ResourceCenterPage';
import PricingPage from './pages/PricingPage';
import DashboardPage from './pages/DashboardPage';
import AnalyticsPage from './pages/AnalyticsPage';
import PlayerPage from './pages/PlayerPage';
import ExplorePage from './pages/ExplorePage';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/create" element={<CreatePage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/character-setting" element={<CharacterSettingPage />} />
      <Route path="/storyboard" element={<StoryboardPage />} />
      <Route path="/resource-center" element={<ResourceCenterPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/analytics" element={<AnalyticsPage />} />
      <Route path="/player/:id" element={<PlayerPage />} />
      <Route path="/explore" element={<ExplorePage />} />
    </Routes>
  );
};

export default App;